import React from 'react';

const JobText = (props) => {
  var toText = 'To: ';
    var to = props.to;
    if (props.to === '') {
        toText = '-';
        to = 'Currently'
    }
    return(
      <div>
        <h4><b>{props.rol}</b></h4>
        <p>{props.company}</p>   
        <p>From {props.from} {toText} {to}</p>
        <p></p>
      </div>
    )
}

export default JobText;